import { isNullOrUndefined } from './isNullOrUndefined';
import { isArray } from './isArray';
import { isObjectType } from './isObjectType';

export const isObject = (value) =>
	!isNullOrUndefined(value) && !isArray(value) && isObjectType(value);
